module.exports = __webpack_public_path__ + "static/img/coming.ca02269.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coming.png
// module id = uMlk
// module chunks = 1